import i18n from 'i18next';
import * as React from 'react';
import {
    BrowserRouter,
    Route,
    Switch
} from 'react-router-dom';
import Header from './components/Header';
import Loader from './components/Loader';
import AuthorisationContainer from './containers/Authorisation';
import NotFoundContainer from './containers/NotFound';
import ConfigurationValuesService, { IConfigurationValuesService } from './services/ConfigurationValuesService';
import TrackingService, { ITrackingService } from './services/TrackingService';
import TranslationService from './services/TranslationService';

export interface Props {
    location?: {
        pathname: string;
    };
}

export interface State {
    error: boolean;
    loaded: boolean;
}

class App extends React.Component<Props, State> {
    private trackingService: ITrackingService | undefined;
    private configurationValuesService: IConfigurationValuesService | undefined;

    constructor(props: any) {
        super(props);
        this.state = {
            error: false,
            loaded: false
        };

        this.initAsync();
    }

    private async initAsync() {
        this.configurationValuesService = ConfigurationValuesService.getInstance();
        const configServiceOk = await this.configurationValuesService.initAsync();
        const translationServiceOk = await TranslationService.getInstance().initAsync();

        this.trackingService = new TrackingService();
        this.trackingService.initPiwik({
            url: this.configurationValuesService.piwikUrl,
            siteId: this.configurationValuesService.piwikTrackingId
        });

        i18n.on('languageChanged', () => this.forceUpdate());

        await this.setState({
            error: !configServiceOk || !translationServiceOk,
            loaded: true
        });
    }

    private errorState() {
        // NOTE: this needed to be hard coded, as if this would only show if the config or translations files failed,
        // and if this occurred, then there wouldn't be any translations available anyway...
        return (
            <div className='error-wrapper'>
                Sorry, there was an error. Please try again later.
            </div>
        );
    }

    public render() {
        const {
            error,
            loaded
        } = this.state;

        if (!loaded) {
            return <div/>;
        }

        const routePath = '/translator';
        const pathName = window.location.pathname;
        const basename = pathName.replace(routePath, '') || '/';
        
        return (
            // @ts-ignore - ReactNode not compatible workaround
            <BrowserRouter basename={basename}>
                <Header error={error}/>
                {
                    !error &&
                    <div className='content-wrapper'>
                        <div className='wrapper'>
                            { /* @ts-ignore - ReactNode not compatible workaround */ }
                            <Switch>
                                { /* @ts-ignore - ReactNode not compatible workaround */ }
                                <Route exact={true}
                                       path={routePath}
                                       component={(props: object) => <AuthorisationContainer {...props} />}/>
                                { /* @ts-ignore - ReactNode not compatible workaround */ }
                                <Route component={(props: object) => <NotFoundContainer {...props} />} />
                            </Switch>
                        </div>
                        <Loader/>
                    </div>
                }
                {
                    error &&
                    this.errorState()
                }
            </BrowserRouter>
        );
    }
}

export default App;



// WEBPACK FOOTER //
// ./src/App.tsx